import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';

const DeliveryDate = ({ deliveryDate }) => {
	const labels = useLabels();
	return (
		<>
			{deliveryDate && (
				<div className="ddc-font-size-xsmall text-muted pt-2 pt-lg-2 h-24 d-flex align-items-center">
					{labels.get('GET_IT')} {deliveryDate}
				</div>
			)}
		</>
	);
};

DeliveryDate.propTypes = {
	deliveryDate: PropTypes.string.isRequired
};

export default DeliveryDate;
